module.exports = __webpack_public_path__ + "img/arrive-8c954ad.jpg";